"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _TextFieldPreview = _interopRequireDefault(require("@sprinx/react-mui-fields/TextFieldPreview"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _Email = _interopRequireDefault(require("@material-ui/icons/Email"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _CopyIcon = _interopRequireDefault(require("./CopyIcon"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%',
      display: 'flex'
    },
    url: {
      borderRadius: 4,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      borderStyle: 'solid',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(1),
      overflow: 'auto'
    }
  };
}, {
  name: 'ProductDetailSendLink'
});

var _ref3 = /*#__PURE__*/_react.default.createElement(_CopyIcon.default, null);

var _ref4 = /*#__PURE__*/_react.default.createElement(_Email.default, null);

function ProductDetailSendLink(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var url = typeof window !== 'undefined' ? window.location.href : undefined;

  var handleCopy = _react.default.useCallback( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!navigator) {
              _context.next = 3;
              break;
            }

            _context.next = 3;
            return navigator.clipboard.writeText(url);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [url]);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_TextFieldPreview.default, {
    id: "field",
    type: "text",
    name: "productURL",
    value: url,
    fullWidth: true,
    className: classes.url
  }), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: t('productDetail/productSendLink/copyLinkBtn')
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: handleCopy
  }, _ref3)), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: t('productDetail/productSendLink/sendLinkByEmail')
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    href: "mailto:?subject=".concat(t(product.name), "&body=").concat(url)
  }, _ref4)));
}

process.env.NODE_ENV !== "production" ? ProductDetailSendLink.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string,
    url: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    name: _propTypes.default.arrayOf(_propTypes.default.shape({}))
  })
} : void 0;
ProductDetailSendLink.defaultProps = {
  classes: undefined,
  className: undefined,
  product: undefined
};
var _default = ProductDetailSendLink;
exports.default = _default;